import { Input } from 'antd';
import oddsApi from 'api/oddsApi';
import teaserApi from 'api/teaserApi';
import { useAppDispatch, useAppSelector, useAppTranslation, useErrTranslation } from 'app/hooks';
import InfomationIcon from 'assets/icons/InfomationIcon';
import CustomAmounBettButton from 'components/Commons/CustomAmountBetButton';
import LoadingSpinner from 'components/Commons/LoadingSpinner';
import { showConfirmModal, showErrorModal, showSuccessModal } from 'components/Modals/CommonModals';
import { FOOTBALL_SPORT, PLACE_BET_AUDIO, TEASER_MARKET } from 'consts/app';
import Typo from 'consts/typography';
import {
  changeBetOdds,
  removeAllBets,
  removeAllFutureBets,
  removeBet,
  removeFutureBet,
  selectBets,
  selectFutureBets,
  selectGames,
} from 'features/home/homeSlice';
import { useHandleGetWallets } from 'hooks/useHandleGetWallets';
import { useHandleInsufficientBalance } from 'hooks/useHandleInsufficientBalance';
import { useHandleResponseError } from 'hooks/useHandleResponseError';
import useUserDetail from 'hooks/useUserDetail';
import { OddModel, PlacingBet } from 'models';
import React, { useEffect, useMemo, useState } from 'react';
import { platformStates } from 'redux/platformSlice';
import {
  changeTeaserOdds,
  removeAllTeasers,
  removeTeaser,
  selectLevelPoints,
  selectTeasers,
  selecteCurrentLevel,
  setCurrentLevelPoints,
} from 'redux/teaserSlice';
import BetInformationItem from './BetInformationItem';
import BetSlipInformationItem from './BetSlipInformationItem';
import BetSlipTab from './BetSlipTab';
import BetWrapperButtonForm from './BetWrapperButtonForm';
import FutureBetInformationItem from './FutureBetInformationItem';
import SingleBetList from './SingleBetList';
import TeaserWrapperButtonForm from './TeaserWrapperButtonForm';
import { selectGameOdds } from 'redux/gameSlice';

interface BetSlipFormProps {}
const aud = new Audio(PLACE_BET_AUDIO);
const BetSlipForm: React.FunctionComponent<BetSlipFormProps> = (props) => {
  const t = useAppTranslation();
  const et = useErrTranslation();

  const dispatch = useAppDispatch();
  const bets = useAppSelector(selectBets);
  const teasers = useAppSelector(selectTeasers);
  const futureBets = useAppSelector(selectFutureBets);
  const platform = useAppSelector(platformStates);
  const games = useAppSelector(selectGames);
  const levelPoints = useAppSelector(selectLevelPoints);
  const currentLevel = useAppSelector(selecteCurrentLevel);

  const { getWallet } = useHandleGetWallets();
  const { currentUser } = useUserDetail();
  const handleResponseError = useHandleResponseError();
  const handleInsufficientBalance = useHandleInsufficientBalance();

  const [activeTab, setActiveTab] = useState<number>(1);
  const [comboAmount, setComboAmount] = useState<number>(0);
  const [teaserAmount, setTeaserAmount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const gameOdds = useAppSelector(selectGameOdds);

  useEffect(() => {
    if (!games || games?.length === 0) return;
    const newGameBets = games?.filter((game) => bets.map((x) => x.gameId).includes(game.id));
    const newOdds: OddModel[] = [];
    const newTeasers: OddModel[] = [];

    bets.forEach((bet) => {
      const temp = newGameBets?.find((newGameBet) => bet.gameId === newGameBet.id);
      if (temp) {
        const odd = gameOdds[temp.id][bet.odd.market].find(
          (o) => o.id === bet.odd.id && o.status !== 'LOCKED',
        );
        if (odd) {
          newOdds.push(odd);
          if (temp.sport.group === FOOTBALL_SPORT && TEASER_MARKET.includes(odd.market)) {
            newTeasers.push(odd);
          }
        }
      }
    });
    dispatch(changeBetOdds(newOdds));
    dispatch(changeTeaserOdds(newTeasers));
  }, [games]);

  const onChangeTab = (index: number) => {
    setActiveTab(index);
  };

  const onDeleteSingleBet = (id: string) => {
    dispatch(removeBet(id));
    dispatch(removeTeaser(id));
  };

  const onDeleteSingleFutureBet = (id: string) => {
    dispatch(removeFutureBet(id));
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^[0-9]{1,10}$/;
    const value = event.target.value;
    if (value === '' || regex.test(value)) {
      setComboAmount(Number(value));
    }
  };

  const onChangeTeaser = (event: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^[0-9]{1,10}$/;
    const value = event.target.value;
    if (value === '' || regex.test(value)) {
      setTeaserAmount(Number(value));
    }
  };

  const resetComboAmount = () => {
    setComboAmount(0);
  };

  const resetTeaserAmount = () => {
    setTeaserAmount(0);
  };

  const handleSetField = (value: string) => {
    setComboAmount(Number(value));
  };
  const handleSetTeaserField = (value: string) => {
    setTeaserAmount(Number(value));
  };

  const isHiddenCustom = useMemo(
    () => futureBets.length + bets.length < 2 || futureBets.length + bets.length > 4,
    [futureBets.length, bets.length],
  );

  const isHiddenTeaser = useMemo(() => teasers.length < 2 || teasers.length > 6, [teasers.length]);

  const placeBet = async (value: string) => {
    setIsLoading(true);
    let placingBetRequest: PlacingBet[] = [];
    bets.map((bet) =>
      placingBetRequest.push({
        gameId: bet.gameId,
        oddsId: bet.odd.id,
        amount: bet.singleAmount,
        futureId: '',
      }),
    );

    futureBets.map((bet) =>
      placingBetRequest.push({
        oddsId: bet.odd.id,
        futureId: bet.futureId,
        amount: bet.singleAmount,
        gameId: '',
      }),
    );

    const { ok, error } = await oddsApi.placingComboBet({
      amount: Number(value),
      bets: placingBetRequest.slice().map((bet) =>
        bet.gameId !== ''
          ? {
              gameId: bet.gameId,
              oddsId: bet.oddsId,
              market: bet.market,
            }
          : {
              oddsId: bet.oddsId,
              futureId: bet.futureId,
            },
      ),
    });

    setIsLoading(false);

    if (ok) {
      aud.play();
      getWallet();
      showSuccessModal({
        title: t('bet.success.title'),
        content: t('bet.success.message'),
      });
      resetComboAmount();
      dispatch(removeAllBets());
      dispatch(removeAllTeasers());
      dispatch(removeAllFutureBets());
    }
    if (error) {
      if (error.message === 'error.validate.balance.insufficient') {
        return handleInsufficientBalance();
      }
      if (error?.fieldErrors) {
        showErrorModal({
          content: et(error.fieldErrors.bets[0]),
          title: et(error.title || '', { defaultValue: et('defaultMessage.title') }),
        });
      } else handleResponseError(error);
    }
  };

  const handleDoubleClickOption = (value: string, betType: string) => {
    showConfirmModal({
      content: (
        <p>
          {t('confirmModal.bet', {
            amount: `${value} ${currentUser?.coinDto?.symbol === 'USD' ? 'USD' : '$TBET'}`,
          })}
        </p>
      ),
      width: 360,
      icon: <InfomationIcon />,
      onOk: () => {
        if (betType === 'COMBO') {
          placeBet(value);
        }
        if (betType === 'TEASER') {
          placeTeaserBet(value);
        }
      },
      okText: 'Submit',
      cancelText: 'Cancel',
    });
  };

  const placeTeaserBet = async (value: string) => {
    setIsLoading(true);
    if (level?.id) {
      const placedBets = teasers.map((t) => ({
        oddsId: t.odd.id,
        gameId: t.gameId,
        market: t.odd.market,
      }));
      const { ok, error } = await teaserApi.placeTeaserBets({
        amount: Number(value),
        bets: placedBets,
        pointLevel: level?.value,
      });
      setIsLoading(false);
      if (ok) {
        aud.play();
        getWallet();
        showSuccessModal({
          title: t('bet.success.title'),
          content: t('bet.success.message'),
        });
        resetComboAmount();
        dispatch(removeAllBets());
        dispatch(removeAllTeasers());
        dispatch(removeAllFutureBets());
      }
      if (error) {
        if (error?.fieldErrors) {
          showErrorModal({
            content: et(error.fieldErrors.bets[0]),
            title: et(error.title || '', { defaultValue: et('defaultMessage.title') }),
          });
        } else handleResponseError(error);
      }
    }
  };

  const level = useMemo(() => {
    return levelPoints && levelPoints[currentLevel];
  }, [levelPoints, currentLevel]);

  const handleChangeLevel = (isMinus: boolean) => {
    if (currentLevel === 0 && isMinus) {
      return;
    }
    if (currentLevel === 4 && !isMinus) {
      return;
    }
    dispatch(setCurrentLevelPoints(isMinus ? currentLevel - 1 : currentLevel + 1));
  };

  return isLoading ? (
    <div className="overlay z-max">
      <LoadingSpinner />
    </div>
  ) : (
    <div className="bet-slip-form">
      <BetSlipTab currentTab={activeTab} changeTab={onChangeTab} resetCombo={resetComboAmount} />

      {activeTab === 1 && (
        <>
          {!(futureBets.length + bets.length) ? (
            <div>{/* <EmptyTableIcon /> */}</div>
          ) : (
            <div className="single-bet-list">
              {bets.map((bet, index) => (
                <SingleBetList
                  key={`single-bet-${bet.odd.id}-${index}`}
                  id={bet.odd.id}
                  onDelete={onDeleteSingleBet}
                  type="BET_GAME"
                />
              ))}
              {futureBets.map((futureBet, index) => (
                <SingleBetList
                  key={`single-bet-${futureBet.odd.id}-${index}`}
                  id={futureBet.odd.id}
                  onDelete={onDeleteSingleFutureBet}
                  type="BET_FUTURE"
                />
              ))}
            </div>
          )}
          {/* <AccpeptAllOdd /> */}
        </>
      )}
      {activeTab === 2 && (
        <>
          {bets.length + futureBets.length ? (
            <div className="combo-bet">
              {bets.map((bet) => (
                <div key={`combo-bet-${bet.gameId}-${bet.odd.id}`} className="combo-bet-item">
                  {/* <BetInformationItem id={bet.odd.id} onDelete={onDeleteSingleBet} /> */}
                  <BetSlipInformationItem
                    id={bet.odd.id}
                    onDelete={onDeleteSingleBet}
                    type={'BET_GAME'}
                    betType="Combo"
                  />
                </div>
              ))}
              {futureBets.map((futureBet) => (
                <div
                  key={`combo-bet-${futureBet.futureId}-${futureBet.odd.id}`}
                  className="combo-bet-item"
                >
                  <FutureBetInformationItem
                    id={futureBet.odd.id}
                    onDelete={onDeleteSingleFutureBet}
                    betType="Combo"
                  />
                </div>
              ))}
            </div>
          ) : (
            <div>{/* <EmptyTableIcon /> */}</div>
          )}
          {/* <AccpeptAllOdd /> */}

          {/* {!isHiddenCustom && (
            <>
              <Input
                name="input-value"
                className={`input-secondary ${
                  platform.isDesktop || platform.isLargeDesktop ? Typo.p1 : Typo.p2
                }`}
                placeholder="Bet Amount"
                value={comboAmount}
                onChange={onChange}
              />
              <CustomAmounBettButton
                onSetField={handleSetField}
                onOptionDoubleClick={(value) => handleDoubleClickOption(value, 'COMBO')}
              />
            </>
          )} */}
          <input
            name="input-value"
            className={`input-secondary ${
              platform.isDesktop || platform.isLargeDesktop ? Typo.p1 : Typo.p2
            } input-field__combo`}
            placeholder="Bet Amount"
            value={comboAmount}
            onChange={onChange}
          />
        </>
      )}
      {activeTab === 4 && (
        <>
          {teasers.length ? (
            <div className="combo-bet">
              {teasers.map((bet) => (
                <div key={`combo-bet-${bet.gameId}-${bet.odd.id}`} className="combo-bet-item">
                  <BetInformationItem
                    id={bet.odd.id}
                    onDelete={onDeleteSingleBet}
                    isTeaser={true}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div>{/* <EmptyTableIcon /> */}</div>
          )}
          {/* <AccpeptAllOdd /> */}

          {!isHiddenTeaser && (
            <div className="teaser-input-container">
              <div className="teaser-point-container">
                <p className={`${Typo.p2} primary-text-color`}>{t('teaserBet.teaserPoint')} :</p>
                <div className="teaser-point">
                  <span
                    className={`minus  cursor-pointer ${currentLevel === 0 ? 'disable' : ''}`}
                    onClick={() => handleChangeLevel(true)}
                  >
                    {' '}
                    -{' '}
                  </span>
                  <div className="amount ">{level?.value}</div>
                  <span
                    className={`plus cursor-pointer ${currentLevel === 4 ? 'disable' : ''}`}
                    onClick={() => handleChangeLevel(false)}
                  >
                    {' '}
                    +{' '}
                  </span>
                </div>
              </div>

              <div className="teaser-input">
                <Input
                  name="input-value"
                  className={`input-secondary ${
                    platform.isDesktop || platform.isLargeDesktop ? Typo.p1 : Typo.p2
                  }`}
                  placeholder="Bet Amount"
                  value={teaserAmount}
                  onChange={onChangeTeaser}
                />
                <CustomAmounBettButton
                  onSetField={handleSetTeaserField}
                  onOptionDoubleClick={(value) => handleDoubleClickOption(value, 'TEASER')}
                />
              </div>
            </div>
          )}
        </>
      )}
      {activeTab !== 3 && activeTab !== 4 && (
        <BetWrapperButtonForm
          isSingle={activeTab === 1}
          comboAmount={comboAmount}
          resetComboAmount={resetComboAmount}
        />
      )}

      {activeTab === 4 && (
        <TeaserWrapperButtonForm
          isDisabledButton={isHiddenTeaser}
          teaserAmount={teaserAmount}
          resetComboAmount={resetTeaserAmount}
        />
      )}
    </div>
  );
};

export default BetSlipForm;
